import { commonFilter } from './filter';

export default {
  pageName: 'Keyword Correlation',
  pageId: '20112',
  pagePath: '/opinion/Stats/KeywordCorrelation',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
